import React, { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import Styles from "./styles.module.scss";
import Button from "../../compopnents/button";
import FormHead from "../../compopnents/headings/FromHead";
import classnames from "classnames";
import { navItem } from "aws-amplify";
import { convertFromRaw, convertToRaw, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import { convertToHTML } from "draft-convert";
// import ShareResume from "../../modal/shareResume";
import { getDetails } from './services'
import { useLocation } from 'react-router-dom';
import { makeSideBarActive } from '../../utils/ellowutils';
import * as CONSTANTS from '../../utils/CONSTANTS';
import SideMenu from '../sideMenu';
import DashboardHeader from "../topbar";
import { TabStrip } from "@progress/kendo-react-layout";
import Tab from '../../compopnents/tab';
import StarRating from "../../compopnents/rating/index";
import { checkLevel } from "../../utils/ellowutils";
import mixpanelData, { viewedpageMixpanel } from "../../utils/mixpanel";


function Preview(props: any) {

  const location = useLocation();
  const { candidateLoginId }: any = location.state
  const userloginId = localStorage.getItem("loginId");

  const menu = makeSideBarActive(CONSTANTS.sideMenu, 2)
  const [selectedTab, setSelectedTab] = useState<number>(0);


  const [candidateData, setCandidateData] = useState<any>();
  const [editorState, setEditorState] = useState<any>(
    EditorState.createEmpty()
  );
  const [error, setError] = useState<string | undefined>("");
  const [profileSubmitted, setProfileSubmitted] = useState<boolean>(true);
  const [resumeShare, setResumeShare] = useState<boolean>()

  // useEffect(() => {
    
  //   setCandidateData(props.candaidateData);
  //   setProfileSubmitted(props.profileSubmitted);
    
  // }, [props]);

  const dateConvert = (date: number) => {
    return new Date(date).toLocaleDateString();
  };

  const summaryConvert = (item: any) => {
    if (item) {
      const contentState = editorState.getCurrentContent();
      if (JSON.stringify(convertToRaw(contentState)) !== item) {
        try {
          let abd = draftToHtml(
            convertToRaw(
              EditorState.createWithContent(
                convertFromRaw(JSON.parse(item))
              ).getCurrentContent()
            )
          );
          let strippedHtml = abd.replace(/<[^>]+>/g, "");
          return strippedHtml;
        } catch (e) {
          return item;
        }
      }
    }
  };
  const createMarkup = (html: any) => {
    if (html && html !== null){
      if (html.includes('{"blocks')) {
        let oldblockconverteddata = convertFromRaw(JSON.parse(html));
        let oldblockdataconvertedhtml = convertToHTML(oldblockconverteddata);
  
        html = JSON.stringify(oldblockdataconvertedhtml);
        return {
          __html: DOMPurify.sanitize(html),
        };
      }
      if (html.includes("<p>") || html.includes("<ol") || html.includes("<ul>")) {
        return {
          __html: DOMPurify.sanitize(JSON.parse(html)),
        };
      } else {
        html = "<p>" + html + "</p>";
        return {
          __html: DOMPurify.sanitize(html),
        };
      }
    }
  };
  const onSubmit = () => {
    // let value = submitCheck(candidateData, false);
    // if (!value.error) {
    //   let data = {
    //     userLoginId: userloginId,
    //     candidateStatus: 3,
    //     loginId: props.loginId,
    //     submittedBy: "RECRUITER",
    //   };
    //   props.submitCheck(value.error, data);
    // } else {
    //   setError(value.errorMessage);
    // }
  };

  const container = React.useRef<HTMLDivElement>(null);
  const pdfExportComponent = React.useRef<PDFExport>(null);
  const exportPDFWithMethod = () => {
    let element = container.current || document.body;
    savePDF(element, {
      paperSize: "auto",
      margin: 40,
      fileName: `Report for ${new Date().getFullYear()}`,
    });
  };

  const exportPDFWithComponent = () => {

    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  };

  const shareResume = (data: any) => {
    
  }

 useEffect(() => {
  getDetails(candidateLoginId).then((response) => {
    if(response.status === 1){
      setCandidateData(response.data[0].profile_metadata)
    }
  })
   viewedpageMixpanel();
   
 }, [])
  
  useEffect(() => {
    if (candidateData && candidateLoginId) {
      mixpanelData('New MT - view preview', {
        'distinct_id': localStorage.getItem('Email'),
        'Candidate name': candidateData && candidateData.firstName + candidateData.lastName,
        'Candidate email': candidateData && candidateData.email,
        'login id': candidateLoginId
      })
    }
  }, [candidateData])
  

 let BreadcrumsValues = ['Contract Resources', 'Preview' ]

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu}/>
      <section className="dashboardContent">
      <DashboardHeader 
        title={BreadcrumsValues} 
        searchChange={undefined}
        // popupMenu={true}
        // priority={jobMetadata.priority}
      />
      <TabStrip selected={selectedTab}>
        <Tab title="Preview" >
        <div className={Styles.resourcesProfile}>
          <div className={Styles.profileWrapper}>
            <div className={Styles.profile}>
              <div className={Styles.phead}>
                <div className={Styles.pheadDetails}>
                  { candidateData && <figure>
                    {candidateData && candidateData.image ? (
                      <img src={candidateData.image} />
                    ) : (
                      
                      candidateData.firstName &&
                      candidateData.lastName &&
                      candidateData.firstName.charAt(0) +
                        candidateData.lastName.charAt(0)
                    )}
                  </figure>}
                  <div className={Styles.details}>
                    <h2>
                      {candidateData &&
                        candidateData.firstName + " " + candidateData.lastName}
                    </h2>
                    {candidateData && candidateData.jobRoles && candidateData.jobRoles.length !== 0 ? 
                        <h3>
                        {candidateData &&
                          candidateData.jobRoles &&
                          candidateData.jobRoles[0] &&
                          candidateData.jobRoles[0].name}{" "}
                        | {candidateData && candidateData.positionName}
                      </h3>
                      : ' '
                    }
                    <p>
                    {candidateData &&
                      candidateData.address &&
                      candidateData.address.city}{" "}
                     {candidateData && candidateData.country}{candidateData && candidateData.preference && candidateData.preference.timeZone && Array.isArray(candidateData.preference.timeZone.length) && candidateData.preference.timeZone.map((item: any, key: number) => {
                      return (
                       ' || '+ item.slice(0,9)
                      )
                    })}
                    </p>
                  </div>
                </div>
                {/* <div className={Styles.socialWrap}>
                  <p className={Styles.email}>
                    {candidateData && candidateData.email}
                  </p>
                  <p className={Styles.phone}>
                    +{candidateData && candidateData.phoneNumber}
                  </p>
                  <div className={Styles.social}>
                    {candidateData && candidateData.linkedIn && (

                      <a href={candidateData.linkedIn.includes('https://') ? candidateData.linkedIn : `https://${candidateData.linkedIn}`} target='_blank'>
                         <Icon icon="jam:linkedin-circle" />
                      </a>  
                    )}
                    {candidateData && candidateData.github && (
                    
                      <a href={candidateData.github.includes('https://') ? candidateData.github : `https://${candidateData.github}`} target='_blank'>
                        <Icon icon="jam:github-circle" />
                      </a>
                    )}
                    {candidateData && candidateData.stackoverflow && (
                  
                      <a href={candidateData.stackoverflow.includes('https://') ? candidateData.stackoverflow :`https://${candidateData.stackoverflow}`} target='_blank' >
                      <Icon icon="jam:stackoverflow-circle" />
                    </a>
                    )}
                  </div>
                </div> */}
              </div>
              <div className={Styles.pSummry}>
                {/* <p>{candidateData && summaryConvert(candidateData.summary)}</p> */}
                {candidateData && (
                  <div
                    className="preview"
                    dangerouslySetInnerHTML={
                      candidateData && createMarkup(candidateData.summary)
                    }
                  ></div>
                )}
                <FormHead>
                  {candidateData &&
                    candidateData.techStack &&
                    candidateData.techStack.length > 0 &&
                    candidateData.techStack[0] !== undefined && (
                      <strong>Core Skills</strong>
                    )}
                </FormHead>
                <div className={Styles.skillsWrap}>
                  {candidateData &&
                    candidateData.techStack &&
                    candidateData.techStack.map((item: any) => {
                      return (
                        <div className={Styles.skills}>
                          {item.skill.skillName}
                        </div>
                      );
                    })}
              </div>
            {  ((candidateData && candidateData.ellowScreeningCertifications) || (candidateData &&candidateData.companyRatings)) && 
            <div>              
              <div className={Styles.subHead}>ASSESSMENT</div>
              <div className={Styles.assessmentWrap}>
                { candidateData && candidateData.assessmentLevel && 
                  <>
                    <div className={Styles.assessHead}>SKILLS RATING</div>
                      <div className={Styles.formHead}>
                        <FormHead>{checkLevel(candidateData && candidateData.assessmentLevel)?.title} </FormHead>
                      </div>
                      <p>
                        {checkLevel(candidateData && candidateData.assessmentLevel)?.summary}
                      </p>
                  </>
                }
                <div className={Styles.ratingBlockWrap}>
                  { candidateData && candidateData.ellowScreeningCertifications &&  candidateData.ellowScreeningCertifications.map((item: any) => {
                    return (
                      <div className={Styles.ratingBlock}>
                        <div className={Styles.ratinghead}>
                          {item.skills && item.skills.name}
                          <div className="ratingPreview">
                            <StarRating defaultValue={item.overallRating} disabled={true} />
                          </div>
                          <span><em>{(item.overallRating === 0 || item.overallRating === undefined) ? '0' : item.overallRating}</em> out of 5.0</span>
                        </div>
                        {item && item.subSkills && item.subSkills.map((data: any) => {
                          return (
                            <div className={Styles.ratingList}>
                              <p>{data.subSkills.name}</p>
                              <div className="ratingPreview">
                                <StarRating defaultValue={data.skillRating} disabled={true}/>
                              </div>
                            </div>
                          )
                        }) }
                      </div>
                    )
                  }) }
                </div>
              </div>
              { candidateData && candidateData.companyRatings && <div className={Styles.assessmentWrap}>
                <div className={Styles.assessHead}>COMPANY RATING</div>
                  <div className={Styles.ratingBlockWrap}>
                    {candidateData && candidateData.companyRatings && candidateData.companyRatings.map((item: any) => {
                      return (
                        !item.disabled &&
                        <div className={Styles.ratingBlock}>
                          <div className={Styles.formHead}>
                            <FormHead>{item.companyName}</FormHead>
                            <span>{item.designation} ({item.startDate && item.endDate && new Date(item.startDate).toDateString().slice(3) + '-'}{item.startDate && item.endDate && new Date(item.endDate).toDateString().slice(3)})</span>
                          </div>
                          <p>
                            {item.comment}
                          </p>
                          { item.overAllRating && 
                            <div className={Styles.ratinghead}>
                              Overall rating
                              <div className="ratingPreview">
                                <StarRating defaultValue={item.overAllRating} disabled={true} />
                              </div>
                              <span><em>{item.overAllRating}</em> out of 5.0</span>
                            </div>
                          }
                          { item.subRatings.codeQuality && 
                            <div className={Styles.ratingList}>
                              <p>Code quaility</p>
                              <div className={Styles.ratings}>
                                <div className="ratingPreview">
                                  <StarRating defaultValue={item.subRatings.codeQuality} disabled={true} />
                                </div>
                              </div>
                            </div>
                          }
                          { item.subRatings.productivity && 
                            <div className={Styles.ratingList}>
                              <p>Productivity</p>
                              <div className={Styles.ratings}>
                                <div className="ratingPreview">
                                  <StarRating defaultValue={item.subRatings.productivity} disabled={true} />
                                </div>
                              </div>
                            </div>
                          }
                          { item.subRatings.communication && 
                            <div className={Styles.ratingList}>
                              <p>Communication</p>
                              <div className={Styles.ratings}>
                                <div className="ratingPreview">
                                  <StarRating defaultValue={item.subRatings.communication} disabled={true} />
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      )
                    }) }
                  </div>
                </div> 
              }
            </div>
          }

                {candidateData &&
                  candidateData.workHistory &&
                  candidateData.workHistory.length > 0 &&
                  candidateData.workHistory[0] !== undefined && (
                    <div className={Styles.subHead}>WORK HISTORY</div>
                  )}
                {candidateData &&
                  candidateData.workHistory &&
                  candidateData.workHistory.map((item: any) => {
                    return (
                      <div>
                        <div className={Styles.expHead}>
                          <div className={Styles.title}>
                            <h4>{item.companyName}</h4>
                            <p>{item.designation}</p>
                          </div>
                          <div className={Styles.date}>
                            {dateConvert(item.startDate)} –{" "}
                            {item.endDate
                              ? dateConvert(item.endDate)
                              : "Present"}
                          </div>
                        </div>
                        {item.description && (
                          <div
                            className="preview"
                            dangerouslySetInnerHTML={
                              item.description && createMarkup(item.description)
                            }
                          ></div>
                        )}
                        {/* <p>
                          {item.description && summaryConvert(item.description)}
                        </p> */}
                      </div>
                    );
                  })}
                {candidateData &&
                  candidateData.project &&
                  candidateData.project.length > 0 &&
                  candidateData.project[0] !== undefined && (
                    <div className={Styles.subHead}>Projects</div>
                  )}
                {candidateData &&
                  candidateData.project &&
                  candidateData.project.map((item: any) => {
                    return (
                      <div>
                        <div className={Styles.expHead}>
                          <div className={Styles.title}>
                            <h4>{item.name}</h4>
                            <p>Client: {item.companyName}</p>
                          </div>
                          {/* <div className={Styles.date}>
                          {item.doneFor ? 'doneFor: ' + item.doneFor : ''}
                        </div> */}
                        </div>
                        <div className={Styles.projectSkills}>
                          {item.skills &&
                            item.skills.length !== 0 &&
                            item.skills.map((item: any, key: number) => {
                              return (
                                <div className={Styles.item}>
                                  {item.skillName}
                                </div>
                              );
                            })}{" "}
                        </div>
                        {/* <p>
                          {item.contribution &&
                            summaryConvert(item.contribution)}
                        </p> */}
                        {item.contribution && (
                          <div
                            className="preview"
                            dangerouslySetInnerHTML={
                              item.contribution &&
                              createMarkup(item.contribution)
                            }
                          ></div>
                        )}
                      </div>
                    );
                  })}

                {candidateData &&
                  candidateData.education &&
                  candidateData.education.length > 0 &&
                  candidateData.education[0] !== undefined && (
                    <div className={Styles.subHead}>Academic Details</div>
                  )}
                {candidateData &&
                  candidateData.education &&
                  candidateData.education.map((item: any) => {
                    return (
                      <div className={Styles.expHead}>
                        <div className={Styles.title}>
                          <h4>{item.institution}</h4>
                          <p>{item.degree} </p>
                        </div>
                        <div className={Styles.date}>
                          {item.startDate
                            ? dateConvert(item.startDate) + " - "
                            : ""}
                          {item.endDate ? dateConvert(item.endDate) : "Present"}
                        </div>
                      </div>
                    );
                  })}
                {candidateData &&
                  candidateData.certification &&
                  candidateData.certification.length > 0 &&
                  candidateData.certification[0] !== undefined && (
                    <div className={Styles.subHead}>
                      Awards and Certifications
                    </div>
                  )}
                {candidateData &&
                  candidateData.certification &&
                  candidateData.certification.map((item: any) => {
                    return (
                      <div className={Styles.expHead}>
                        <div className={Styles.title}>
                          <h4>{item.name}</h4>
                          <p>{item.certifiedYear} </p>
                        </div>
                      </div>
                    );
                  })}
                {candidateData &&
                  candidateData.language &&
                  candidateData.language.length > 0 &&
                  candidateData.language[0] !== undefined && (
                    <div className={Styles.subHead}>languages</div>
                  )}
                {candidateData &&
                  candidateData.language &&
                  candidateData.language.map((item: any) => {
                    return (
                      <div className={Styles.expHead}>
                        <div className={Styles.title}>
                          <h4>{item.name}</h4>
                          <p>{item.proficiency} </p>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        {/* </PDFExport> */}
        {/* {resumeShare && <ShareResume onClose={() => setResumeShare(false)} clickHandler={shareResume}/>} */}
        <div className={Styles.shareandprint}>
          {/* <button onClick={() => setResumeShare(true)}>
              <Icon icon="charm:share"  />
            </button> */}
          {/* <button onClick={exportPDFWithComponent}>
            <Icon icon="lucide:printer" />
          </button> */}
        </div>
        </div>
        </Tab>
          </TabStrip>
      </section>
    </section>
  );
}

export default Preview;
